import ShippingPage from './ShippingPage'

export default {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/project/:projectId/shipping',
      component: ShippingPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/shipping/shippingConfig.js